import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  undo: {
    description: 'Undo hotkey name',
    defaultMessage: 'Undo',
    id: 'GEMSS1',
  },
  redoCtrlY: {
    description: 'Redo hotkey name using Ctrl+Y',
    defaultMessage: 'Redo (Ctrl+Y)',
    id: 'Lj6ZTn',
  },
  redoCtrlShiftZ: {
    description: 'Redo hotkey name using Ctrl+Shift+Z',
    defaultMessage: 'Redo (Ctrl+Shift+Z)',
    id: 'Oxafy7',
  },
});
